var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVcClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.267,
    height: 36.267,
    viewBox: "0 0 36.267 36.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20313",
    "data-name": "Group 20313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32046",
    "data-name": "Path 32046",
    d: "M23.267,10.133a1.133,1.133,0,0,0-2.267,0V22.6a1.133,1.133,0,0,0,.571.984L29.5,28.117a1.133,1.133,0,0,0,1.124-1.967l-7.362-4.207Z",
    transform: "translate(-5.133 -2.2)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32047",
    "data-name": "Path 32047",
    d: "M18.133,36.267A18.133,18.133,0,1,0,0,18.133,18.133,18.133,0,0,0,18.133,36.267ZM34,18.133A15.867,15.867,0,1,1,18.133,2.267,15.867,15.867,0,0,1,34,18.133Z",
    fill: "#6b6b6b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcClock);
export default __webpack_public_path__ + "static/media/vc-clock.1ee162f462c20c955f511d4f0c9132cd.svg";
export { ForwardRef as ReactComponent };